import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, toDisplayString as _toDisplayString, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-471b43cd"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "bsb" }
const _hoisted_2 = { class: "bsb_box" }
const _hoisted_3 = { class: "bsb_box_item" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "设备编码", -1))
const _hoisted_5 = { class: "bsb_box_item" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "设备名称", -1))
const _hoisted_7 = { class: "bsb_box_item" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "设备型号", -1))
const _hoisted_9 = { class: "bsb_box_item" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "关联用户", -1))

import { ref, onMounted, nextTick } from 'vue'
  import { useRoute, useRouter } from "vue-router"
  import { useStore } from "vuex"
  import { QRCodeType } from '@/enum'
  import { Toast } from 'vant'
  import { getSbInfo, getBarcodeContent, bindingDevice } from '@/apis/WorkOrderAPI'
  import vScanCode from '@/components/common/ScanCode.vue'

  
export default /*#__PURE__*/_defineComponent({
  setup(__props) {

  const route = useRoute()

  const router = useRouter()

  const store = useStore()

  let openCode = ref<boolean>(false)

  let info: any = ref({})

  const closePopup = () => {
      openCode.value = false
  }

  // 扫码回调
  const onDecode = (data: string[]): void => {
      nextTick(() => {
          openCode.value = false
      })
      getBarcodeContent({
          barcode: data[0]
      }).then(res => {
          if (res.code === 200 && res.data.barcodeType === QRCodeType.SB) {
              getInfo(res.data.id)
          } else {
              Toast({ message: '请扫描正确的设备码' })
          }
      })
  }

  //重新扫码
  const continueScanning = () => {
      openCode.value = true
  }

  // 互殴设备信息
  const getInfo = (id: string) => {
      getSbInfo(id)
        .then(res => {
            if (res.code === 200) {
                info.value = res.data
            }
        })
  }

  // 提交
  const submit = () => {
      bindingDevice({
          deviceId: info.value.id,
          userIds: store.state.userInfo.companyUser.id
      }).then(res => {
          if (res.code === 200) {
              Toast.success({ message: '绑定成功', duration: 2000, forbidClick: true })
              setTimeout(() => {
                  router.go(-1)
              }, 2000)
          }
      })
  }

  onMounted(() => {
      let id: any = route.query.id
      getInfo(id)
  })

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _hoisted_4,
        _createElementVNode("span", null, _toDisplayString(_unref(info).code), 1)
      ]),
      _createElementVNode("div", _hoisted_5, [
        _hoisted_6,
        _createElementVNode("span", null, _toDisplayString(_unref(info).name), 1)
      ]),
      _createElementVNode("div", _hoisted_7, [
        _hoisted_8,
        _createElementVNode("span", null, _toDisplayString(_unref(info).model), 1)
      ]),
      _createElementVNode("div", _hoisted_9, [
        _hoisted_10,
        _createElementVNode("span", null, _toDisplayString(_unref(store).state.userInfo.realname) + "/" + _toDisplayString(_unref(store).state.userInfo.companyUser.dmodel.name), 1)
      ])
    ]),
    _createElementVNode("div", { class: "bsb_footer" }, [
      _createElementVNode("div", {
        class: "bsb_footer_jx",
        onClick: continueScanning
      }, "重新扫码"),
      _createElementVNode("div", {
        class: "bsb_footer_tj",
        onClick: submit
      }, "提交")
    ]),
    _createVNode(vScanCode, {
      openCode: _unref(openCode),
      infos: ['请扫描设备码'],
      onClosePopup: closePopup,
      onOnDecode: onDecode
    }, null, 8, ["openCode"])
  ]))
}
}

})